// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JuckidLsJdc_SFIGCJHT{align-items:center;gap:8px;margin-top:-22px;padding-bottom:10px;padding-left:20px;display:flex}.rcxxhb3NBUpFjVcIaCBO{margin:0 3px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `JuckidLsJdc_SFIGCJHT`,
	"toggle": `rcxxhb3NBUpFjVcIaCBO`
};
export default ___CSS_LOADER_EXPORT___;
